import { useEffect, useState } from 'react'

import { useMyIntention } from 'modules/intention/hooks/useMyIntention'
import { useUser } from 'modules/user/hooks/useUser'

/**
 * ### useIntentionJustPublished ###
 *
 * My intention is just published if:
 * - I have an intention now
 * - There were a moment before when I had not while my informations were already loaded
 */
export const useIntentionJustPublished = () => {
  const me = useUser()
  const myIntention = useMyIntention()
  const [onceDidNotHaveAnIntention, setOnceDidNotHaveAnIntention] = useState(
    me.isLogged && !me.loading && !me.intention,
  )

  useEffect(() => {
    if (me.isLogged && !me.loading && !me.intention) {
      setOnceDidNotHaveAnIntention(true)
    }
  }, [me.intention, me.isLogged, me.loading])

  return myIntention && onceDidNotHaveAnIntention
}
